import {useReservation} from 'context/reservation';
import {LeaderGuestFlag} from 'utils/guestForm';
import {
  canSkipIV,
  isIVRequiredForGuest,
  isRegisterBlockedWithoutIV,
} from '@chekin/shared/guest-form';
import {IV_PROCESS_TYPE} from '@chekin/core';
import {useGetGuestId} from './useGetGuestId';
import {useGuest} from './useGuest';
import {useIVComputedDetails} from './useIVComputedDetails';

function useIVRegistrationGate() {
  const {isDataLoaded, isIVEnabled, isGuestRegisterBlocked} = useIVComputedDetails();
  const {isBiometricMatchForAll, housing} = useReservation();
  const guestId = useGetGuestId();
  const {guest} = useGuest({id: guestId});

  const isLeaderGuest = guest?.is_leader ?? LeaderGuestFlag.get();
  const policy = {
    isIVEnabled,
    isGuestRegisterBlocked,
    isBiometricMatchForAll,
    isLeaderGuest,
  };

  return {
    isIVRequiredForGuest: isIVRequiredForGuest(policy),
    isRegisterBlockedWithoutIV: isRegisterBlockedWithoutIV(policy),
    canSkipIV: canSkipIV({
      ...policy,
      isDataLoaded,
      isIVOnProperty:
        housing?.identity_verification_process_type === IV_PROCESS_TYPE.onProperty,
    }),
  };
}

export {useIVRegistrationGate};
